module.exports = __webpack_public_path__ + "img/media-3.78efa589.jpg";